<template>
    <div class="payment-list">
        <div class="box box-shadow is-clearfix">
            <div class="header">
                <h3>{{ $t('payments.component.headline') }}</h3>
                <div v-if="!payments.length">
                    <p>
                        {{ $t('payments.component.copyNoPayments') }}
                    </p>
                </div>
                <div v-else>
                    <p v-if="!compact" v-html="$t('payments.component.copy', {'threshold': thresholdFormatted})"></p>
                    <p v-else v-html="$t('payments.component.copyCompact', {'payments_link': getPaymentsLink()})"></p>
                </div>
            </div>
            <table class="table is-striped is-bordered" v-if="payments.length">
                <thead v-if="!compact">
                <tr>
                    <th>{{ $t('payments.component.table.booking') }}</th>
                    <th>{{ $t('payments.component.table.totalAmount') }}</th>
                    <th>{{ $t('payments.component.table.amountPaidOut') }}</th>
                    <th>{{ $t('payments.component.table.commissionPercent') }}</th>
                    <th v-if="country === 'de'">{{ $t('payments.component.table.commissionAmountNet') }}</th>
                    <th v-if="country === 'de'">{{ $t('payments.component.table.commissionAmountGross') }}</th>
                    <th v-else>{{ $t('payments.component.table.commissionAmount') }}</th>
                    <th>{{ $t('payments.component.table.payoutAmount') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(payment, index) in payments" :key="index" v-if="!compact">
                    <td>
                        <router-link exact :to="{ name: 'booking-detail', params: { bookingId: payment.booking_id, lang: lang } }">
                            {{ payment.booking_number }}
                        </router-link>
                    </td>
                    <td>
                        {{ payment.total | currency($getDefaultCurrency().code, lang) }}
                    </td>
                    <td>
                        {{ payment.deposit_value | currency($getDefaultCurrency().code, lang) }}
                    </td>
                    <td>
                        {{ payment.commission_percent }} %
                    </td>
                    <td v-if="country === 'de'">
                        {{ (payment.commission_value - payment.commission_vat_amount) | currency($getDefaultCurrency().code, lang) }}
                    </td>
                    <td v-else>
                        {{ payment.commission_value | currency($getDefaultCurrency().code, lang) }}
                    </td>
                    <td v-if="country === 'de'">
                        {{ payment.commission_value | currency($getDefaultCurrency().code, lang) }}
                    </td>
                    <td>
                        {{ payment.payout_amount | currency($getDefaultCurrency().code, lang)  }}
                    </td>
                </tr>

                <tr v-if="!compact">
                    <td :colspan="country === 'de' ? 7 : 6"></td>
                </tr>
                <tr>
                    <td :colspan="country === 'de' ? 6 : 5"><strong>{{ $t('payments.component.sum') }}:</strong></td>
                    <td><strong>{{ sumTotalFormatted }}</strong></td>
                </tr>
                <tr>
                    <td :colspan="country === 'de' ? 6 : 5">{{ $t('payments.component.threshold') }}:</td>
                    <td>{{ thresholdFormatted }}</td>
                </tr>
                <tr>
                    <td :colspan="country === 'de' ? 6 : 5">{{ $t('payments.component.missingAmountUntilPayout') }}:</td>
                    <td>
                        <span>
                            {{ Math.max(0, threshold - sumTotal) | currency($getDefaultCurrency().code, lang) }}
                            <span v-if="(threshold - sumTotal) <= 0">*</span>
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="(threshold - sumTotal) <= 0" class="annotation is-pulled-right" v-html="$t('payments.component.noMissingAmountUntilPayout', {amount: sumTotalFormatted})"></p>
        </div>
    </div>
</template>

<script>
import {AppModel} from '../../../models';
import filters from '../../../filters';

export default {
    name: 'payment-list',
    props: {
        compact: {
            type: Boolean,
            'default': () => false,
        },
    },
    filters: filters,
    data() {
        return {
            threshold: 0,
            country: null,
            payments: [],
        };
    },
    created() {
        this.startBootstrapInterval();
    },

    destroyed() {
        this.clearBootstrapInterval();
    },
    computed: {
        lang() {
            return AppModel.lang;
        },
        thresholdFormatted() {
            return filters.currency(this.threshold, this.$getDefaultCurrency().code, this.lang);
        },
        sumTotal() {
            return this.payments.reduce((a, b) => {
                return a + b.payout_amount;
            }, 0);
        },
        sumTotalFormatted() {
            return filters.currency(this.sumTotal, this.$getDefaultCurrency().code, this.lang);
        }
    },
    methods: {
        clearBootstrapInterval() {
            clearInterval(this.bootstrapInterval);
        },
        startBootstrapInterval() {
            this.clearBootstrapInterval();
            this.bootstrapInterval = setInterval(() => {
                if(AppModel.activeCampground) {
                    this.clearBootstrapInterval();
                    this.initData();
                }
            }, 50);
        },
        initData() {
            this.threshold = AppModel.activeCampground.settings.payout_threshold;
            this.country = AppModel.activeCampground.country;
            this.payments = AppModel.activeCampground.pending_payout_data;
        },
        getPaymentsLink() {
            let params = Object.assign({}, this.$route.params);
            const link = {
                name: 'payments',
                params: params,
            };
            const url = this.$router.resolve(link).href;
            const name = this.$t('generic.menu.payments');
            return `<a href="${url}">${name}</a>`;
        },
    },
};
</script>

<style lang="scss">
    @import './payment-list.scss';
</style>




// WEBPACK FOOTER //
// src/views/components/payment-list/payment-list.vue